import cn from "classnames";
import {
  eachMonthOfInterval,
  endOfYear,
  format,
  getMonth,
  isSameMonth,
  startOfYear,
} from "date-fns";

import { getCurrentLocale } from "@packages/shared/utils/getCurrentLocale";

import { Text } from "@/components/Text";

import styles from "./CalendarMonth.module.scss";

interface CalendarMonthsProps {
  currentDate: Date;
  onMonthChange: (monthIndex: number) => void;
}

export const CalendarMonths = ({
  currentDate,
  onMonthChange,
}: CalendarMonthsProps): React.JSX.Element | null => {
  const months = eachMonthOfInterval({
    start: startOfYear(currentDate),
    end: endOfYear(currentDate),
  });

  const getMonthClasses = (month: Date) => {
    return cn(styles.month, {
      [styles.today]: isSameMonth(month, new Date()),
      [styles["same-month"]]: isSameMonth(month, currentDate),
    });
  };

  return (
    <div className={styles.container}>
      {months.map((date, i) => (
        <div
          key={i}
          onClick={() => onMonthChange(getMonth(date))}
          className={getMonthClasses(date)}
        >
          <Text variant="text-2-medium">
            {format(date, "MMM", { locale: getCurrentLocale() })}
          </Text>
        </div>
      ))}
    </div>
  );
};
